export const vendorList = (state, rootState) => {
	return state.vendorList;
}

export const objVendorEdit = (state, rootState) => {
	return state.objVendorEdit;
}

export const vendorManufacturers = (state, rootState) => {
  return state.vendorManufacturers;
}

export const vendorManufacturerRanges = (state, rootState) => {
	return state.vendorManufacturerRanges;
}

export const vendorManufacturerLinks = (state, rootState) => {
	return state.vendorManufacturerLinks;
}

export const objVendorSelectEdit = (state, rootState) => {
	return state.objVendorSelectEdit;
}

export const objAppRanges = (state, rootState) => {
	return state.objAppRanges;
}

export const vendorsIni = (state, rootState) => {
	return state.vendorsIni;
}

export const vendorDepartmentBranches = (state, rootState) => {
  return state.vendorDepartmentBranches;
}
